import { Record } from 'immutable'

export class ImportFile extends Record({
    id: undefined,
    imported_at: undefined,
    name: undefined,
    description: undefined,
}) {}
